import React from 'react';

export const AWSIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19.685" viewBox="0 0 20 19.685">
        <g id="web-service-amazon-web-services" transform="translate(-0.5 -0.681)">
            <path id="Path_7800" data-name="Path 7800" d="M.5,6.2a.435.435,0,0,1,.574-.417L8.9,8.4a.435.435,0,0,1,.3.409V20.552a.435.435,0,0,1-.574.409l-7.774-2.7a.435.435,0,0,1-.3-.409ZM11.8,20.6a.435.435,0,0,0,.583.409l7.826-2.739a.435.435,0,0,0,.287-.409V6.274a.435.435,0,0,0-.565-.417L12.109,8.343a.435.435,0,0,0-.3.417Z" transform="translate(0 -0.663)" />
            <path id="Path_7801" data-name="Path 7801" d="M10.668,5.758a.435.435,0,0,0,.235,0l7.548-2.07a.435.435,0,1,0,0-.87L10.9.7a.435.435,0,0,0-.235,0l-7.443,2a.435.435,0,1,0,0,.87Z" transform="translate(-0.299)" />
        </g>
    </svg>
);